import { Drawer, List } from "@mui/material";
import Box from "@mui/material/Box";
import { AuthState } from "context/AuthContext";
import { grey } from "@mui/material/colors";

import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar/Navbar";
import { useTheme } from "@mui/material/styles";
import DrawerListItem from "./DrawerListItem/DrawerListItem";
import { admin, services } from "data/authData"; // services used by drawer list filtering

const drawerWidth = 240;
const miniDrawerWidth = 60;
/** Clears the fixed AppBar (default MUI Toolbar ≈ 64px). */
const NAVBAR_CLEARANCE = 8;

const serviceIconStyle = { color: grey[300], sx: { transform: "scale(1.3)", p: 2 } };

const listColorSX = {
	// selected and (selected + hover) states

	"&& .Mui-selected, && .Mui-selected:hover": {
		bgcolor: grey[900],
		color: "white",
		"&, & .MuiListItemIcon-root": {
			color: "white",
		},
		"&, & .MuiListItemText-primary": {
			color: "white",
		},
	},
	// hover states
	"& .MuiListItemButton-root:hover": {
		bgcolor: grey[300],
		"&, & .MuiListItemIcon-root": {
			color: grey[800],
		},
	},
};

const DashboardWithOpenSideNav = ({
	drawerList,
	searchParamName,
	navSpace = 1,
	service,
	pathName,
	rootPath,
	navBasePath,
}) => {
	// drawer open/close
	const [open, setOpen] = useState(false);
	const [drawerElements, setDrawerElements] = useState();

	const theme = useTheme();

	const { user } = AuthState();

	const hasAxisAccess = () => user?.role?.[admin] || user?.role?.AXIS;

	const SetDrawerElements = () => {
		let service;
		setDrawerElements(
			Object.keys(drawerList)?.reduce((acc, row) => {
				if (!drawerList[row].display) return acc;
				// AXIS section: only show in drawer if user has service-level axis tag
				if (row === "axis" && !hasAxisAccess()) return acc;
				acc.push(drawerList[row]);
				if (row === pathName) service = { ...drawerList[row] };
				return acc;
			}, [])
		);

		setOpen(false);
	};

	useEffect(() => {
		SetDrawerElements();
	}, [drawerList, user]);

	return (
		<Box width="100%">
			<Navbar />
			<Box display="flex" justifyContent="space-between">
				<Drawer
					sx={{
						width: drawerWidth,
						flexShrink: 0,
						"& .MuiDrawer-paper": {
							width: drawerWidth,
							boxSizing: "border-box",
						},
					}}
					variant="permanent"
					open={open}
					onClose={() => setOpen(!open)}>
					{/* Side nav offset is fixed so large content navSpace does not add empty space above items */}
					<Box width="100%" paddingTop={NAVBAR_CLEARANCE} />

					<List sx={listColorSX}>
						{drawerElements &&
							Object.keys(drawerElements)?.map((key, index) => {
								const service = drawerElements[key];
								return (
									<DrawerListItem
										key={service.key}
										service={service}
										currentPage={pathName}
										rootPath={rootPath}
										open={open}
										listSX={listColorSX}
										parentPath={rootPath}
										navBasePath={navBasePath}
									/>
								);
							})}
					</List>
				</Drawer>
				<Box width={`calc(100% - ${drawerWidth}px)`}>
					<Box pt={navSpace} />
					{user && <Outlet context={[pathName, service]} />}
				</Box>
			</Box>
		</Box>
	);
};

export default DashboardWithOpenSideNav;
